<select #selfSelect (change)="update(selfSelect.value)" class="text-xs md:text-sm bg-ponder outline-none w-full p-1 pb-[5px] border border-transparent focus:border-ponder-bright text-slate-200 ">
    @for (kvp of getOptions() ; track kvp[0] ; let index = $index) {
        @if (index == 0) {
            <!-- Always show the first option (without a count next to it) -->
            <option value="{{ kvp[0] }}" class="hover:bg-ponder-linkhover">{{ kvp[0] }}</option>
        } @else if (kvp[1]) {
            <!-- Only show other options if they have a count greater than 0 -->
            <option value="{{ kvp[0] }}" class="hover:bg-ponder-linkhover">{{ kvp[0] }} ({{ kvp[1] }})</option>
        }
    }
</select>